import { connect } from 'react-redux';
import { loadAdvisor } from '@app/actions/advisors';
import { clearCreditCardProcessing } from '@app/actions/credit_card_processing';
import CreatedChat from './created_chat';
import Const from '../../config/const';
import { getAdvisorXfmProgram, getUuidFromChatConfig } from '../../config/util';
import {
  connectChatProvider,
  disconnectChatProvider,
  sendMessage
} from '../../actions/connected_chat';
import {
  cancelChat, changeTopUpState, hangupChat, hideTopUpBanner, purchaseOnBack,
  purchaseSuccess, setTopupPaidMinutes
} from '../../actions/chat';
import withPGTranslation from '../../config/withPGTranslation';

const mapStateToProps = ({
  chat, pubnub: { ownUuid }, user: { user }, topup, creditCardProcessing: { error }, advisors
}) => {
  const uuid = getUuidFromChatConfig(chat);
  return ({
    ...chat,
    topupState: topup,
    ownUuid,
    uuid,
    userId: user && user.id,
    isNewUser: chat && chat.selectDurationKind === Const.selectDurationKind.newUser,
    creditCardProcessingError: error,
    advisorXfmProgram: getAdvisorXfmProgram({ advisors, advisorId: chat.advisorId }),
    userXfmProgram: user && user.xfmProgram
  });
};

export default connect(
  mapStateToProps,
  {
    connectChatProvider,
    disconnectChatProvider,
    cancelChat,
    sendMessage,
    hangupChat,
    purchaseOnBack,
    purchaseSuccess,
    loadAdvisor,
    hideTopUpBanner,
    changeTopUpState,
    setTopupPaidMinutes,
    clearCreditCardProcessing
  }
)(withPGTranslation(CreatedChat));
